// extracted by mini-css-extract-plugin
export default {"container":"Title_container__y+qGZ","boy":"Title_boy__8xkzk","balloon":"Title_balloon__gfruq","buttonSend":"Title_buttonSend__9jFCq"};